const handleStyleBoxClick = (event) => {

    let styleBoxEl = event.target;
    let style = styleBoxEl.closest('[data-style-type]')?.getAttribute('data-style-type');

    if (!style) {
        return;
    }

    let previousSelectedElements = document.querySelectorAll('[data-style-type] .active');
    if (previousSelectedElements) {
        previousSelectedElements.forEach((previousSelectedElement) => {
            previousSelectedElement?.classList.remove('active')
        });
    }

    styleBoxEl.closest('.style-grid-card-content')?.classList.add('active');

    let previousSelectedImageEl = document.querySelector('[data-image-style-type]:not(.d-none)');
    if (previousSelectedImageEl) {
        previousSelectedImageEl.classList.add('d-none');
    }

    let styleImageEl = document.querySelector(`[data-image-style-type="${style}"]`);
    if (styleImageEl) {
        styleImageEl.classList.remove('d-none');
    }

    let previousSelectedImageElMobi = document.querySelector('.mobile-section [data-image-style-type]:not(.d-none)');
    if (previousSelectedImageElMobi) {
        previousSelectedImageElMobi.classList.add('d-none');
    }

    let styleImageElMobi = document.querySelector(`.mobile-section [data-image-style-type="${style}"]`);
    if (styleImageElMobi) {
        styleImageElMobi.classList.remove('d-none');
    }
}

const scrollToDiv = (style) => {
    let elementToScroll = document.querySelector(`.mobile-section #${style}`);

    if (elementToScroll) {
        elementToScroll.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
}

document.querySelectorAll('.subscription-style-grid [data-style-type]').forEach(styleBoxEl => {
    styleBoxEl.addEventListener('click', (event) => {
        handleStyleBoxClick(event);
        const style = styleBoxEl.getAttribute('data-style-handle');
        if (style.length) {
            scrollToDiv('style-handle-' + style);
        }
    })
})

const handleStyleChange = (event) => {
    const tabLink = event.target

    let tabId = tabLink.getAttribute('data-tabcontent');
    if (!tabId) {
        tabId = tabLink.querySelector('a[data-tabcontent]')?.getAttribute('data-tabcontent');
    }

    document.querySelector(`.subscription-style-grid ${tabId} .style-grid-card-content.active`)?.classList.remove('active');
    document.querySelector(`.subscription-style-grid ${tabId} .style-grid-card-content`)?.classList.add('active');
    let styleImages = document.querySelectorAll('.subscription-style-grid .desktop-section .style-grid-image-container');

    let flag = 0;
    styleImages.forEach((styleImage) => {
        styleImage?.classList.add('d-none')
        if (flag === 0 && tabId?.replace('#', '') === styleImage.getAttribute('data-style_group')) {
            styleImage.classList.remove('d-none')
            flag = 1
        }
    })
}

document.querySelectorAll('.subscription-style-grid .tablink').forEach( link => {
  link.addEventListener('click', (event) => handleStyleChange(event))
})